export const LOOKER_HOSTS = ['https://looker-api.salecycle.com', 'https://salecyclepbl.cloud.looker.com'];
export const OPACITY_VISIBLE = 1;
export const OPACITY_HIDDEN = 0;
export const DEFAULT_DASHBOARD_ID = 'new_business_aggregates::msc_client_landing_page';

/** Locales accepted by the Looker embed URL API. When the app locale is not in this list (e.g. jp), we fall back to 'en' so the dashboard still loads. */
export const LOOKER_SUPPORTED_LOCALES = ['en', 'fr', 'es', 'it'] as const;

export function getLookerLocale(i18nLanguage: string): string {
  const base = i18nLanguage?.split('-')[0] ?? 'en';
  return (LOOKER_SUPPORTED_LOCALES as readonly string[]).includes(base) ? base : 'en';
}
